module.exports = __webpack_public_path__ + "de7796e534ecca62c9b999f370f2e281.png";